import { useSearch } from "wouter"
import cx from "clsx"
import { MicrosoftSignInButton } from "../../../components/MicrosoftSignInButton"
import { ErrorCallout } from "@rawa/ui/ErrorCallout"
import { paths } from "../../../paths"
import typography from "@rawa/ui/styles/typography.module.css"
import styles from "./LoginPage.module.scss"

export function LoginPage() {
  const search = useSearch()
  const params = new URLSearchParams(search)
  const redirectTo = params.get("redirect") ?? paths.admin
  // The SSO callback refuses a principal that Entra authenticated but that is
  // not assigned to this application, and sends them back here with a reason.
  const notAuthorized = params.get("error") === "not_authorized"

  return (
    <div className={styles.page}>
      <h1 className={cx(typography.h2, styles.heading)}>Login</h1>
      {notAuthorized && (
        <ErrorCallout>
          Your account is not authorized to use this application. Ask an
          administrator if you need access.
        </ErrorCallout>
      )}
      <div className={styles.card}>
        <MicrosoftSignInButton
          href={`/api/auth/login?redirect=${encodeURIComponent(redirectTo)}`}
        />
      </div>
    </div>
  )
}
